import { ApiContext, apiContextFetch } from "@/hooks/api/base"
import { BulkEmailRecipientData } from "@/components/bulk-email/recipient-item"

export interface EmailRecipientsParams {
  household_ids?: string[]
  contact_ids?: string[]
  person_ids?: string[]
}

export interface EmailRecipientsResponse {
  recipients: BulkEmailRecipientData[]
}

export async function fetchEmailRecipients(context: ApiContext, params: EmailRecipientsParams) {
  return apiContextFetch<EmailRecipientsResponse>(context, "email_recipients", {
    method: "POST",
    body: JSON.stringify(params),
  })
}
